import Img from "gatsby-image"
import React, { useContext } from "react"
import Slider from "react-slick"
import { css } from "styled-components"
import { UIContext } from "../../components/shared/layout"
import BreakpointImage from "../atoms/breakpoint-image"
import Block from "../atoms/layout-primitives/block"
import { T, Text } from "../atoms/text"
import VariantContainer from "../atoms/variant-container"
import mergeVariants from "../util/merge-variants"

const ClientsGrid = ({
  title,
  titleLine,
  containerVariants,
  titleVariants,
  blockVariants,
  mobileLogos,
  tabletLogos,
  desktopLogos,
}) => {
  const {
    state: { breakpoint, clientLoaded },
  } = useContext(UIContext)

  return (
    <Block
      variants={mergeVariants(
        [
          css`
            grid-column: 1 / -1;
            background: var(--white);
          `,
          css`
            box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.07);
          `,
        ],
        containerVariants
      )}
    >
      <Text
        as="h2"
        variants={mergeVariants(
          [
            css`
              ${T.sm.h2`400`}
              display: block;
              text-align: center;
              grid-column: 1 / -1;
              color: var(--slate);
              margin-bottom: 32px;
            `,
            css`
              ${T.md.h2`400`}
              margin-top: 48px;
              margin-bottom: 0;
            `,
            css`
              ${T.lg.h2`400`}
              font-size: 36px;
              margin-top: 64px;
            `,
          ],
          titleVariants
        )}
      >
        {title}
      </Text>
      {titleLine === true && (
        <VariantContainer
          variants={[
            {
              gridColumn: "1 / -1",
              margin: "16px auto 0 auto",
              justifySelf: "center",
              width: "48px",
              borderBottom: "2px solid #BF4320",
            },
            {
              marginTop: "24px",
              width: "64px",
            },
            { marginTop: "32px", width: "96px" },
          ]}
        ></VariantContainer>
      )}
      <Block
        variants={mergeVariants(
          [
            css`
              padding: 24px 24px 80px;
              box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.07);
              .slick-dots {
                bottom: -48px;
              }
            `,
            css`
              margin-bottom: 0;
              padding: 48px 32px;
              box-shadow: none;
            `,
            css`
              padding: 64px;
            `,
          ],
          blockVariants
        )}
      >
        {breakpoint !== "sm" ? (
          <BreakpointImage
            imageVariants={{
              sm: tabletLogos,
              lg: desktopLogos,
            }}
          />
        ) : (
          clientLoaded && (
            <Slider dots arrows={false}>
              {mobileLogos.map((logo) => (
                <Img
                  fluid={logo.node.childImageSharp.fluid}
                  alt={logo.node.base.split(".")[0]} // use Filename as alt text for SEO
                  key={logo.node.id}
                  imgStyle={{ objectFit: "contain" }}
                />
              ))}
            </Slider>
          )
        )}
      </Block>
    </Block>
  )
}

export default ClientsGrid
